import { render, staticRenderFns } from "./FcVideo.vue?vue&type=template&id=765318d0&scoped=true&"
import script from "./FcVideo.vue?vue&type=script&lang=ts&"
export * from "./FcVideo.vue?vue&type=script&lang=ts&"
import style0 from "./FcVideo.vue?vue&type=style&index=0&id=765318d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765318d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
